import { compose, noop } from 'lodash/fp';
import { connect } from 'react-redux';

import {
    areAllFieldsTouched,
    changeCustomerValue,
    getCustomerError,
    getCustomerValue,
    isCheckoutFieldRequired,
    isFieldTouched,
    touchField,
} from '../slices';

import { createCheckoutFormFieldDataTestId } from './createCheckoutFormFieldDataTestId';
import { processError } from './processError';

export const connectCheckoutField = ({
    defaultName,
    defaultValue = '',
    valueKey = 'value',
    mapAdditionalProps = noop,
    mapAdditionalDispatchProps = noop,
}: $TSFixMe = {}) =>
    compose(
        connect(
            // @ts-expect-error $TSFixMeError: Property 'name' does not exist on type '{}'.
            (state, { name = defaultName, helper: defaultHelper, optionalFieldHelper }) => {
                // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
                const required = isCheckoutFieldRequired(state, { name });
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                const optionalHelper = optionalFieldHelper && !required ? optionalFieldHelper : null;
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                const helper = optionalHelper || defaultHelper;

                return {
                    // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
                    [valueKey]: getCustomerValue(state, { name, defaultValue }),
                    // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
                    touched: isFieldTouched(state, { name }),
                    // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
                    allTouched: areAllFieldsTouched(state),
                    // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
                    error: getCustomerError(state, { name }),
                    required,
                    helper,
                    'data-test-id': createCheckoutFormFieldDataTestId(name),
                    ...mapAdditionalProps(state),
                };
            },
            // @ts-expect-error $TSFixMeError: Property 'name' does not exist on type '{}'.
            (dispatch, { name = defaultName }) => ({
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { heapService }: $TSFixMe) => void' is not assignable to para...
                onChange: (_e: $TSFixMe, value: $TSFixMe) => dispatch(changeCustomerValue({ key: name, value })),
                onBlur: () => {
                    dispatch(touchField(name));
                },
                ...mapAdditionalDispatchProps(dispatch, { name }),
            })
        ),
        processError
    );
